module.exports = __webpack_public_path__ + "static/media/bg5.04dc9edd.jpg";